import React from "react";
import {useLocation} from "react-router-dom";

export const useQuery = () => {
    const {search} = useLocation();

    const getQueryResult = React.useMemo(() => new URLSearchParams(search), [search])
    return [getQueryResult, search];
}